import Cookies from 'js-cookie'
import store from '@/store'
import Api from '@/api/Api'
import Configuration from '@/classes/Configuration'

global.cookie = Cookies

class Session {

  static init() {
    let token = Session.getJwtCookie()
    if (token && token != null) {
      Session.login(token)
    } else {
      Session.logout()
    }
  }

  static login(jwt_token, expiration = "") {
    let user = Session.getUser(jwt_token)
    Session.setJwtCookie(jwt_token, expiration)

    let api = new Api()
    api.set_jwt(jwt_token)
    store.commit('SET_CURRENT_USER', Session.getUser(jwt_token))

    api.myProfile().then((result) => {
      let merged = Object.assign({}, user, result)
      merged.overwrite = true
      store.commit('SET_CURRENT_USER', merged)
    })

    Configuration.setOrganizationConfig(user)
  }

  // get the current user from token payload
  static getUser(jwt_token) {
    try {
      let payload = jwt_token.split('.')[1]
      return JSON.parse(atob(payload))
    } catch (e) {
      Session.logout()
    }
  }

  static logout() {
    // remove xtable sortings
    localStorage.removeItem('contactsTableSettings')
    localStorage.removeItem('companiesTableSettings')
    localStorage.removeItem('segmentsTableSettings')

    Session.deleteJwtCookie()
    store.commit('EMPTY_CURRENT_USER')
  }

  static setJwtCookie(jwt_token, expiration_time = "") {
    if (expiration_time) {
      Cookies.set('jwt_token', jwt_token, { expires: expiration_time })
    } else {
      Cookies.set('jwt_token', jwt_token)
    }
  }

  static getJwtCookie() {
    return Cookies.get('jwt_token')
  }

  static deleteJwtCookie() {
    Cookies.remove('jwt_token')
  }

}
global.session = Session

export default Session



// WEBPACK FOOTER //
// ./src/classes/Session.js